import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import ItemList from 'flarum/common/utils/ItemList';
import listItems from 'flarum/common/helpers/listItems';
import HomeHero from './HomeHero';
import HomeWelcome from './HomeWelcome';
import HomeDiscussions from './HomeDiscussions';
import HomeDiscussions_Latest from './HomeDiscussions_Latest';
import HomeDiscussions_Laste from './HomeDiscussions_Laste';
//import HomeTags from './HomeTags';
import HomeStats from './HomeStats';
import { slug } from '../../common';
//import FrontpageDiscussionsSlider from './FrontpageDiscussionsSlider';
//import AbstractSlider from './AbstractSlider';
import Text_1 from './Text_1';
import Text_2 from './Text_2';
import HomeActivityLeaderboard_Post from './HomeActivityLeaderboard_Post';
import HomeActivityLeaderboard_Discussions from './HomeActivityLeaderboard_Discussions';

// Make translation calls shorter
const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.home`;

export default class HomePage extends Page {
	oninit(vnode) {
		super.oninit(vnode);

		app.history.push('home');
		this.bodyClass = 'App--home';
		app.setTitle(app.translator.trans('core.forum.index.meta_title_text'));
	}

	view() {
		let UpdateAlert;
		if (app.initializers.has('fof-terms')) {
			UpdateAlert = flarum.extensions['fof-terms'].components.UpdateAlert;
		}

		let groups = this.blockGroups().toArray();
        // class container
		return (
			<div className='HomePage'>
				{UpdateAlert && <UpdateAlert />}
				<div className='HomePage-blocks_wrapper'>
					<ul className='HomePage-block_groups'>
						{groups.map((blocks) => (
							<li className={`item-${blocks.itemName}`}>
								<ul className='HomePage-blocks'>
									{listItems(blocks.toArray())}
									{blocks.toArray().length % 2 > 0 && (
										<div className='HomePage-empty_block'>
											{/* Empty item, used to fix alignment of the last (not empty) item if there is an odd number of items */}
										</div>
									)}
								</ul>
							</li>
						))}
					</ul>
				</div>
			</div>
		);
	}

	blockGroups() {
		const groups = new ItemList();

		groups.add('hero', new ItemList().add('hero', <HomeHero />), 100);
		//groups.add('welcome', this.welcomeBlocks(), 100);
		groups.add('text_1', this.text_1_Blocks(), 95);

		groups.add('newest', this.newestBlocks(), 94);

		//groups.add('laste', this.lasteBlocks(), 93);

		//groups.add('latest', this.latestBlocks(), 90);

		groups.add('text_2', this.text_2_Blocks(), 80);


		groups.add('top', this.topBlocks(), 70);

		groups.add('leaderboards', this.leaderboardBlocks(), 60);

		//groups.add('tags', new ItemList().add('tags', <HomeTags />), 50);

		return groups;
	}

	welcomeBlocks() {
		const blocks = new ItemList();
		blocks.add('welcome', <HomeWelcome />, 100);
		/*if (app.initializers.has('fof/frontpage')) {
			blocks.add('slider', <FrontpageDiscussionsSlider />, 50);
		} else {
			blocks.add('slider', <AbstractSlider />, 50);
		}*/
		return blocks;
	}

	text_1_Blocks() {
		const blocks = new ItemList();
		blocks.add('text_1', <Text_1 />, 100);
		//blocks.add('stats', <HomeStats />, 90);
		
		return blocks;
	}
	text_2_Blocks() {
		const blocks = new ItemList();
		blocks.add('text_2', <Text_2 />, 100);
		
		return blocks;
	}

	newestBlocks() {
		const blocks = new ItemList();
	
        /*
            map.latest = '-lastPostedAt';
            map.top = '-commentCount';
            map.newest = '-createdAt';
            map.oldest = 'createdAt';
        */
		blocks.add(
			'newestDiscussions',
			<HomeDiscussions_Latest
				title={t(`${prfx}.discussions.newest.title`)}
				params={{ filter: { home: 'true' }, sort: '-createdAt' }}
				//preloadedKey='discussions'
				showBtn={true}
				showallBtn={true}
			/>,
			100,
		);
		return blocks;
	}

	lasteBlocks() {
		const blocks = new ItemList();
	
        /*
            map.latest = '-lastPostedAt';
            map.top = '-commentCount';
            map.newest = '-createdAt';
            map.oldest = 'createdAt';
        */
		blocks.add(
			'lasteDiscussions',
			<HomeDiscussions_Laste
				title={t(`${prfx}.discussions.laste.title`)}
				params={{ filter: { home: 'true' } }}
				//preloadedKey='latestDiscussions'
				showBtn={true}
			/>,
			100,
		);
		return blocks;
	}

	latestBlocks() {
		const blocks = new ItemList();
	
        /*
            map.latest = '-lastPostedAt';
            map.top = '-commentCount';
            map.newest = '-createdAt';
            map.oldest = 'createdAt';
        */
		blocks.add(
			'latestDiscussions',
			<HomeDiscussions_Latest
				title={t(`${prfx}.discussions.latest.title`)}
				params={{ filter: { home: 'true' } }}
				preloadedKey='latestDiscussions'
				showBtn={true}
				showallBtn={true}
			/>,
			100,
		);
		return blocks;
	}

	topBlocks() {
		const blocks = new ItemList();
		blocks.add(
			'discussions',
			<HomeDiscussions
				title={t(`${prfx}.discussions.trending.title`)}
				//params={{ filter: { home: true } }}
                params={{ filter: { home: 'true' }, sort: '-hotness' }}
				preloadedKey='discussions'
			/>,
			100,
		);
        /*
            map.latest = '-lastPostedAt';
            map.top = '-commentCount';
            map.newest = '-createdAt';
            map.oldest = 'createdAt';
        */
		blocks.add(
			'mostActiveDiscussions',
			<HomeDiscussions
				title={t(`${prfx}.discussions.most_active.title`)}
				params={{ filter: { home: 'recent' }, sort: '-commentCount' }}
				preloadedKey='mostActiveDiscussions'
			/>,            
			50,
		);
		return blocks;
	}

	//HomePage.prototype.leaderboardBlocks = function () {
	//	const blocks = new ItemList();
	//	blocks.add('posts-leaderboard', <HomeActivityLeaderboard />, 10);
	//	return blocks;
	//};
	leaderboardBlocks() {
		const blocks = new ItemList();
		blocks.add('posts-leaderboard', <HomeActivityLeaderboard_Post />, 10);
		blocks.add('discussions-leaderboard', <HomeActivityLeaderboard_Discussions />, 10);
		return blocks;
	}
}